import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import ReactDOMServer from 'react-dom/server';

import BackgroundImage from '../../../BackgroundImage';
import Popup from '../../../Popup';

class PlayerLookupInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterString: '',
            expand: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleExpand = this.handleExpand.bind(this);
        this.handleCollapse = this.handleCollapse.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.handleExpandClick = this.handleExpandClick.bind(this);
        this.togglePopup = this.togglePopup.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleExpandClick() {
        if (this.props.warnBeforePlayerChange) {
            this.togglePopup();
        } else {
            this.handleExpand();
        }
    }

    handleExpand() {
        if (this.props.allowPlayerChange) {
            this.setState({
                expand: true,
                filterString: '',
            },
            () => {
                setTimeout(this.inputRef.focus(), 10);
            });
        }
    }

    handleCollapse() {
        this.setState({ expand: false });
    }

    handleChange(e) {
        this.setState({ filterString: e.target.value });
        // this.props.onChange(e);
    }

    handleKeyUp(e) {
        if (e.key === 'Escape') {
            this.handleCollapse();
        }
    }

    handleClickOutside(e) {
        if (!this.wrapperRef.contains(e.target)) {
            this.handleCollapse();
        }
    }

    togglePopup() {
        this.setState(prevState => ({
            showPopup: !prevState.showPopup,
        }));
    }

    render() {
        const {
            name,
            selectClass,
            parentClass,
            playerOptions,
            allowPlayerChange,
            showBye,
            position,
            onSelect,
            utrById,
            showTeamName,
            teamName,
            warnBeforePlayerChange,
            isMobile,
            PTTPosition,
            PTTError,
            'data-testid': dataTestId,
        } = this.props;

        const { expand, filterString, showPopup } = this.state;

        return (
            <div className={`card-player-select ${allowPlayerChange ? 'allow-player-change' : ''} ${parentClass}`} ref={(el) => { this.wrapperRef = el; }} data-testid={dataTestId || undefined}>
                <div className="input-wrapper">
                    <div
                        className={`player-select ${expand ? 'd-none' : 'd-block'} ${selectClass} ${PTTError ? 'text-danger' : ''}`}
                        onClick={() => { if (allowPlayerChange) { this.handleExpandClick(); } }}
                        data-testid={dataTestId && `${dataTestId}.player-select-display`}
                    >{name} {allowPlayerChange && <i className="uts uts-expand" />}
                    </div>
                    {expand && (
                        <React.Fragment>
                            <input
                                ref={(el) => { this.inputRef = el; }}
                                className={`player-select`}
                                value={filterString || ''}
                                onChange={this.handleChange}
                                onKeyUp={this.handleKeyUp}
                                placeholder="Type to filter players..."
                                data-testid={dataTestId && `${dataTestId}.filter-input`}
                            />
                            <i className={`uts uts-collapse`} onClick={this.collapseList} />
                        </React.Fragment>
                    )}
                    {!!PTTPosition && <div className="ptt-position" data-testid={dataTestId && `${dataTestId}.ptt-position`}>{PTTPosition}</div>}
                </div>

                {expand && (
                    <div className={`select-options`}>
                        <ul>
                            {!!playerOptions.length && playerOptions.map(player => {
                                // const HTML = ReactDOMServer.renderToStaticMarkup();
                                const regex = new RegExp(filterString, 'i');
                                return filterString && !player.displayName.match(regex) ? null
                                    : (
                                        <li key={player.id} onClick={() => { this.handleCollapse(); onSelect(position, player); }} data-testid={dataTestId && `${dataTestId}.option-${player.id}`}>
                                            <div className={`row player-search-option`}>
                                                <div className="col-2 d-flex justify-content-center">
                                                    <BackgroundImage
                                                        baseUrl={'/v1/player/'}
                                                        defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                                                        images={player.playerProfileImages}
                                                        imageType={'profile'}
                                                        parentStylesClass={'profile-image'}
                                                    />
                                                </div>
                                                <div className="col-10 d-block">
                                                    <div className="name" data-testid={dataTestId && `${dataTestId}.option-${player.id}.name`}><span>{player.displayName}<small> {utrById(player.id)}</small></span></div>
                                                    <div className="place" data-testid={dataTestId && `${dataTestId}.option-${player.id}.place`}>{showTeamName && teamName ? teamName : player.location?.display}</div>
                                                </div>
                                            </div>
                                        </li>
                                    );
                            })}
                            {!playerOptions.length && (
                                <li className="mt16" data-testid={dataTestId && `${dataTestId}.no-players-message`}>No players to add...</li>
                            )}
                        </ul>
                        <div className="footer bt">
                            <div className="row no-gutters">
                                <div className={`${showBye ? 'col-6' : 'col-12'}`}>
                                    <div className="footer-button" onClick={() => { this.handleCollapse(); onSelect(position, {}); }} data-testid={dataTestId && `${dataTestId}.clear-btn`}>
                                        <i className="uts uts-clear-player" /> Clear
                                    </div>
                                </div>
                                {showBye && (
                                    <div className="col-6">
                                        <div className="footer-button bl" onClick={() => { this.handleCollapse(); onSelect(position, { type: { value: 'bye' } }); }} data-testid={dataTestId && `${dataTestId}.bye-btn`}>
                                            <i className="uts uts-player-bye" /> Bye
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
                {showPopup && (
                    <Popup
                        onCloseClick={this.togglePopup}
                        className="popup-sm"
                        config={{
                            noPadding: false,
                            topGradient: true,
                            style: {
                                height: isMobile ? 180 : 160,
                                maxHeight: '80vh',
                            },
                        }}
                        data-testid={dataTestId && `${dataTestId}.warn-popup`}
                    >
                        <div>
                            <p className="fs15 text-center mb16" data-testid={dataTestId && `${dataTestId}.warn-popup.message`}>{warnBeforePlayerChange}</p>
                            <div className="row">
                                <div className="col-6 jcc">
                                    <button
                                        type="button"
                                        className="btn btn-md btn-primary btn-block"
                                        onClick={() => {
                                            this.togglePopup();
                                            this.handleExpand();
                                        }}
                                        data-testid={dataTestId && `${dataTestId}.warn-popup.ok-btn`}
                                    >
                                        OK
                                    </button>
                                </div>
                                <div className="col-6 jcc">
                                    <button type="button" className="btn btn-md btn-primary btn-block" onClick={this.togglePopup} data-testid={dataTestId && `${dataTestId}.warn-popup.cancel-btn`}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </Popup>
                )}
            </div>
        );
    }
}
PlayerLookupInput.propTypes = {
    'data-testid': PropTypes.string,
};

PlayerLookupInput.defaultProps = {
    'data-testid': null,
};

export default PlayerLookupInput;
